import { Home } from 'containers/home'
import { MenuContextProvider } from 'context/menu-context'
import { GlobalStyle } from 'styles/global'

export const App = () => (
  <MenuContextProvider>
    <GlobalStyle />
    <Home />
  </MenuContextProvider>
)
